import React from "react";

export default function Training() {
  return (
    <div
      id="training"
      className="items-center px-6 py-8 text-white bg-mesanfaz-black sm:px-8 md:px-12 md:py-12"
    >
      <div className="text-4xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl">
        training
      </div>
      <div className="pt-12">
        <ol className="relative border-l border-mesanfaz-gray">
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Private Class : Backend Developer with Golang
            </h3>
            <time className="block mb-2 leading-none">Eduwork</time>
            <time className="block mb-2 leading-none">Online - Indonesia</time>
            <time className="block mb-2 leading-none">Dec 2023 - Mar 2024</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Accomplished a simple API project called Simple Ecommerce
                  System API. Simple Ecommerce System API is a simple but
                  effective API and is designed to manage user data, products,
                  shopping carts, orders, midtrans payments and use docker
                  compose watch.
                </li>
                <li>
                  Completed a simple API project Task Management API. Task
                  Management API is designed to manage task data with local
                  image upload feature, user management and integration with
                  docker compose watch.
                </li>
                <li>
                  Accomplished a simple API project called User Management API.
                  User Management API is built to manage users with forgotten
                  password features using custom hashes and integrating docker
                  compose watch.
                </li>
                <li>
                  Completed a simple API project, which was called Simple
                  Product Management API. Simple Product Management API is
                  developed using Fiber and used for product management with
                  users.
                </li>
                <li>
                  Enhanced comprehension and expertise with achieved 99% course
                  completion smoothly utilizing Fiber and Docker tools for
                  backend development.
                </li>
              </ul>
            </div>
          </li>
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              React JS Web Frontend
            </h3>
            <time className="block mb-2 leading-none">Sanbercode</time>
            <time className="block mb-2 leading-none">Online - Indonesia</time>
            <time className="block mb-2 leading-none">Jan 2023 - Apr 2023</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Achieved 99% completion rate on assigned project utilizing
                  ReactJS to integrate smoothly with provided API demonstrating
                  proficiency in frontend development and API integration.
                </li>
                <li>
                  Improved competency utilizing Tailwind CSS successfully
                  resulting in efficiency improvements for creating responsive
                  and advanced website interfaces.
                </li>
                <li>
                  Enhanced expertise in ReactJS with 99% improved lesson
                  completion progress for website development efficiency and
                  proficiency.
                </li>
                <li>
                  Improved comprehension and greater proficiency utilizing
                  advanced features in JavaScript ES6 for code optimization and
                  functionality.
                </li>
                <li>
                  Completed studies according to specified timeline and proved
                  commitment to accomplish academic achievements on time.
                </li>
              </ul>
            </div>
          </li>
          <li className="ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Fullstack Developer
            </h3>
            <time className="block mb-2 leading-none">DumbWays</time>
            <time className="block mb-2 leading-none">Online - Indonesia</time>
            <time className="block mb-2 leading-none">Dec 2021 - Mar 2022</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Accomplished a simple project DumbGram. DumbGram is a social
                  media website that allows users to interact by posting photos,
                  commenting, liking posts, following other users and sending
                  messages to other users.
                </li>
                <li>
                  Completed a simple project called Cinema Online. Cinema Online
                  is an online video streaming service website with paid content
                  access for users and this website allows video access anywhere
                  and anytime.
                </li>
                <li>
                  Accomplished a simple project called Todo App, a mobile
                  application that functions for task management.
                </li>
                <li>
                  Completed a simple project Calculator APP, a mobile
                  application designed to perform calculation processes.
                </li>
                <li>
                  Explored insights and expertise as Fullstack Developer with
                  focus on Javascript programming language.
                </li>
              </ul>
            </div>
          </li>
        </ol>
      </div>
    </div>
  );
}
